"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = exports.UserProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var router_1 = require("next/router");
var UserContext = react_1.createContext(undefined);
var userFetcher = function (url) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var response;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.ok ? response.json() : { user: null, accessToken: null }];
        }
    });
}); };
var UserProvider = function (props) {
    var supabaseClient = props.supabaseClient, _a = props.callbackUrl, callbackUrl = _a === void 0 ? '/api/auth/callback' : _a, _b = props.profileUrl, profileUrl = _b === void 0 ? '/api/auth/user' : _b, _c = props.user, initialUser = _c === void 0 ? null : _c, _d = props.fetcher, fetcher = _d === void 0 ? userFetcher : _d;
    var _f = tslib_1.__read(react_1.useState(initialUser), 2), user = _f[0], setUser = _f[1];
    var _g = tslib_1.__read(react_1.useState(null), 2), accessToken = _g[0], setAccessToken = _g[1];
    var _h = tslib_1.__read(react_1.useState(!initialUser), 2), isLoading = _h[0], setIsLoading = _h[1];
    var _j = tslib_1.__read(react_1.useState(), 2), error = _j[0], setError = _j[1];
    var pathname = router_1.useRouter().pathname;
    var checkSession = react_1.useCallback(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var _a, user_1, accessToken_1, _e_1, error_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetcher(profileUrl)];
                case 1:
                    _a = _b.sent(), user_1 = _a.user, accessToken_1 = _a.accessToken;
                    if (accessToken_1) {
                        supabaseClient.auth.setAuth(accessToken_1);
                        setAccessToken(accessToken_1);
                    }
                    setUser(user_1);
                    if (!user_1)
                        setIsLoading(false);
                    return [3 /*break*/, 3];
                case 2:
                    _e_1 = _b.sent();
                    error_1 = new Error("The request to " + profileUrl + " failed");
                    setError(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [profileUrl]);
    // Get cached user on every page render.
    react_1.useEffect(function () {
        function runOnPathChange() {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setIsLoading(true);
                            return [4 /*yield*/, checkSession()];
                        case 1:
                            _a.sent();
                            setIsLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        runOnPathChange();
    }, [pathname]);
    react_1.useEffect(function () {
        var authListener = supabaseClient.auth.onAuthStateChange(function (event, session) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        // Forward session from client to server where it is set in a Cookie.
                        // NOTE: this will eventually be removed when the Cookie can be set differently.
                        return [4 /*yield*/, fetch(callbackUrl, {
                                method: 'POST',
                                headers: new Headers({ 'Content-Type': 'application/json' }),
                                credentials: 'same-origin',
                                body: JSON.stringify({ event: event, session: session })
                            }).then(function (res) {
                                if (!res.ok) {
                                    var error_2 = new Error("The request to " + callbackUrl + " failed");
                                    setError(error_2);
                                }
                            })];
                    case 1:
                        // Forward session from client to server where it is set in a Cookie.
                        // NOTE: this will eventually be removed when the Cookie can be set differently.
                        _a.sent();
                        // Fetch the user from the API route
                        return [4 /*yield*/, checkSession()];
                    case 2:
                        // Fetch the user from the API route
                        _a.sent();
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); }).data;
        return function () {
            authListener === null || authListener === void 0 ? void 0 : authListener.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var value = {
        isLoading: isLoading,
        user: user,
        accessToken: accessToken,
        error: error
    };
    return react_1.default.createElement(UserContext.Provider, tslib_1.__assign({ value: value }, props));
};
exports.UserProvider = UserProvider;
var useUser = function () {
    var context = react_1.useContext(UserContext);
    if (context === undefined) {
        throw new Error("useUser must be used within a UserProvider.");
    }
    return context;
};
exports.useUser = useUser;
//# sourceMappingURL=UserProvider.js.map